import {FC} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import UserBranchTableFilter from './components/UserBranchTableFilter'
import UserBranchTable from './components/UserBranchTable'

type Props = {
  className: string
}
const BranchUserPage: FC<Props> = (props) => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'BRANCH.USER.PAGE_TITLE'})}</PageTitle>
      <div className='card mb-10'>
        <UserBranchTableFilter />
        <div className='card-body p-10'>
          <UserBranchTable />
        </div>
      </div>
    </>
  )
}

export default BranchUserPage
